<div class="loader-container">
  <ods-loader max="100" variant="spinner"></ods-loader>
</div>
